/**
 * FadeBgImageTabs — custom element for "fade_background_image_tabs" section.
 *
 * Desktop: tab buttons at the bottom cross-fade the background image.
 * Mobile:  dot navigation swaps the image + the top content panel.
 *
 * Classes managed:
 *   fbit__panel--active     → visible image panel
 *   fbit__tab--active       → highlighted desktop tab
 *   fbit__mobile-panel--active → visible mobile content
 *   fbit__dot--active       → filled dot
 */

if (!customElements.get('fade-bg-image-tabs')) {
  class FadeBgImageTabs extends HTMLElement {
    connectedCallback() {
      this._panels       = Array.from(this.querySelectorAll('.fbit__panel'));
      this._tabs         = Array.from(this.querySelectorAll('.fbit__tab'));
      this._mobilePanels = Array.from(this.querySelectorAll('.fbit__mobile-panel'));
      this._dots         = Array.from(this.querySelectorAll('.fbit__dot'));
      this._current      = 0;

      // Desktop tab clicks
      this._tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this._goTo(i));
      });

      // Mobile dot clicks
      this._dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this._goTo(i));
      });
    }

    _goTo(index) {
      if (index === this._current || index < 0 || index >= this._panels.length) return;

      // Image panels
      this._panels[this._current]?.classList.remove('fbit__panel--active');
      this._panels[index]?.classList.add('fbit__panel--active');

      // Desktop tabs
      this._tabs[this._current]?.classList.remove('fbit__tab--active');
      this._tabs[index]?.classList.add('fbit__tab--active');

      // Mobile content panels
      this._mobilePanels[this._current]?.classList.remove('fbit__mobile-panel--active');
      this._mobilePanels[index]?.classList.add('fbit__mobile-panel--active');

      // Dots
      this._dots[this._current]?.classList.remove('fbit__dot--active');
      this._dots[index]?.classList.add('fbit__dot--active');

      this._current = index;
    }
  }

  customElements.define('fade-bg-image-tabs', FadeBgImageTabs);
}
